import { render, staticRenderFns } from "./button-history.vue?vue&type=template&id=1368cae2&"
import script from "./button-history.vue?vue&type=script&lang=ts&"
export * from "./button-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports